import React from 'react';

import LoadingBar from 'components/LoadingBar';
import SLoadingContainer from './styled';

const LoadingModalContent = ({ loadingText }: { loadingText: string }) => (
  <SLoadingContainer data-test="version-control-modal-loader">
    {loadingText}
    <LoadingBar color="blue" />
  </SLoadingContainer>
);

export default LoadingModalContent;
